module.exports = __webpack_public_path__ + "img/leftPic.090cfd50.png";